import { useEffect } from 'react';
import { checkCustomerIOStatus, logCustomerIOStatus, retryUserIdentification } from './customerio';

function CustomerIOMonitor() {
  useEffect(() => {
    const handleAppStateChange = () => {
      const status = checkCustomerIOStatus();
      logCustomerIOStatus();

      if (status.gistInitialized && !status.userIdentified) {
        retryUserIdentification();
      }
    };

    handleAppStateChange();

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        handleAppStateChange();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    const interval = setInterval(handleAppStateChange, 5 * 60 * 1000);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearInterval(interval);
    };
  }, []);

  return null;
}

export default CustomerIOMonitor;
